import { IoClose } from "react-icons/io5";
import { IoDocumentOutline } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { GiCrossMark } from "react-icons/gi";
import { IoPrintSharp } from "react-icons/io5";
import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import LoadingScreen from "../LoadingScreen";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";

const Make = ({ hideNavbar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const state = useSelector((state) => state.changeTheState);
  const user = state?.user?.emailId?.split("@")[0];
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const authToken = window.sessionStorage.getItem("auth-token");
  const BASEURL_GLOBAL =  process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
    const [tableData, setTableData] = useState([]);
  const [vehicleMake, setVehicleMake] = useState("");
  const [selectedRowIndex, setselectedRowIndex] = useState(null);
  const [makeModelData, setMakeModelData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=459`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setMakeModelData(res?.data);
      })
      .catch((err) => {
        console.log("Error While fetching 459", err);
        setIsLoading(false);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1109`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setData(res?.data);
         setTableData(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("Error While fetching 1109", err);
      });
  };

  // Adding and Removing from the Grid
  const AddToGrid = () => {
    const newValue = {
      MAKE: vehicleMake,
    };
    setTableData([...tableData, newValue]);
    setVehicleMake("");
  };

  const RemoveFromGrid = () => {
    if (tableData.length > 0) {
      const updatedValues = [...tableData];
      if (
        selectedRowIndex !== null &&
        selectedRowIndex >= 0 &&
        selectedRowIndex < updatedValues.length
      ) {
        updatedValues.splice(selectedRowIndex, 1);
        setselectedRowIndex(null);
      } else {
        updatedValues.pop();
      }
      setTableData(updatedValues);
      setVehicleMake("");
    } else {
      alert("Please add data details First");
    }
  };

    // ********************* SAVE **********************
  async function Save() {
    setIsLoading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    const dataMakes = new Set(data?.map((d) => d?.MAKE));
    const filterMakeNotAdded = tableData?.filter(
      (item) => !dataMakes.has(item?.MAKE),
    );
    for (let i = 0; i < filterMakeNotAdded?.length; i++) {
      const value = filterMakeNotAdded[i];
        try {
          const response = await axios.post(
            `${BASEURL_GLOBAL}/globalSpHandler?spname=230`,
            {
              OM_VEHICLE_MAKE:value?.MAKE,
              OM_VEHICLE_MAKE_CREATED_BY:user,
            },
            {
              headers: {
                "auth-token": authToken,
                "session-token": sessiontoken,
              },
            },
          );

          if (response.status === 201) {
            successCount++;
            successMessage = response.data.message;
          } else {
            errorCount++;
            errorMessage = response.data.message;
          }
        } catch (error) {
          setIsLoading(false);
          console.error(
            `Error while Saving Vehicle Make`,
            error,
          );
          alert(error.response.data.message);
        }
    }
    setIsLoading(false);
    if (
      successCount == filterMakeNotAdded?.length &&
      successMessage
    ) {
      alert("Vehicle Make Saved Successfully");
      window.location.reload();
    }
    if (errorMessage) {
      alert(errorMessage);
    }
  }


  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-100vh">
      {!hideNavbar && <AllPagesNavbar />}
      <header className="header__of__main lg:flex justify-between items-end px-3">
        <h1 className="header__of__page">{"VEHICLE MAKE"}</h1>
      </header>

      <div className="flex gap-2 mt-2 items-center text-gray-700 pl-2">
        <IoDocumentOutline
          size={24}
          onClick={() => {
            setVehicleMake("");
          }}
          className="text-blue-800  hover:text-blue-900 transition-all duration-200 drop-shadow-md"
        />
        <FaSave
                    onClick={async () => {
            await Save();
          }}
          size={24}
          className="text-green-400 hover:text-green-500 transition-all duration-200 drop-shadow-md"
        />
        <GiCrossMark
          size={24}
          className="text-red-400 hover:text-red-500 transition-all duration-200 drop-shadow-md"
        />
        <IoPrintSharp
          size={24}
          className="text-purple-400 hover:text-purple-500 transition-all duration-200 drop-shadow-md"
        />
      </div>

      <aside className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-auto border border-gray-300 text-sm">
          <thead class="sticky top-0 w-44">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">S NO</td>
              <td className="py-2 px-4 text-left border border-gray-300">VEHICLE MAKE</td>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr
               className="hover:bg-gray-100 cursor-pointer text-[12px]"
                key={index}
                onClick={() => {
                  setVehicleMake(row?.MAKE);
                  setselectedRowIndex(index);
                }}
              >
                <td className="py-2 px-4 text-right border border-gray-300 w-20">{index + 1}</td>
                <td className="py-2 px-4 text-left border border-gray-300 w-40">{row.MAKE ? row.MAKE : "N/A"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </aside>

      <div className="lg:flex lg:flex-row justify-between items-center text-xs mt-3 bg-gray-100 p-2 m-2 rounded-md">
        <div className="flex">
          <p className="text-red-600 mr-2">Make :</p>
          <input
            className="w-64 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={vehicleMake}
            onChange={(e) => setVehicleMake(e.target.value)}
          ></input>
        </div>
        <div className="flex gap-2">
          <button
            className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => {
              if (!vehicleMake) {
                alert("Kindly Supply Make");
                return;
              } else {
                const make = data?.find((item) => item?.MAKE === vehicleMake);
                if (make) {
                  alert("This Make is available");
                  return;
                } else {
                  AddToGrid();
                }
              }
            }}
          >
            Add
          </button>
          <button
            className=" flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => {
              if (selectedRowIndex !== null) {
                const makeLinked = makeModelData?.find(
                  (item) => item?.MAKE === vehicleMake,
                );
                if (makeLinked) {
                  alert("This Make is Linked to Model");
                  return;
                } else {
                  RemoveFromGrid();
                }
              } else {
                RemoveFromGrid();
              }
            }}
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default Make;
